export default {
    deoval: "Подтвердить удаление",
    location: "Расположение",
}
